import React, { Component } from 'react';
import { HashRouter as Router } from 'react-router-dom';

import AntMainArea from './AntMainArea';
import AntAuthArea from './AntAuthArea';
import { getScreenSizeClass, onScreenChanged, offScreenChanged } from '../../utils/screen';
import AntLocalization from '../../utils/AntLocalization';

import viMessages from 'devextreme/localization/messages/vi.json';
import { locale, loadMessages } from 'devextreme/localization';

class App extends Component {
    constructor(props) {
        super(props);

        loadMessages(viMessages);
        locale(navigator.language);

        this.state = {
            loggedIn: true,
            screenSizeClass: getScreenSizeClass()
        };

        this.userMenuItems = [
            {
                text: AntLocalization.translateText({ vi: 'Hồ sơ', en: 'Profile', fr: 'Profil', es: 'Perfil', id: 'Profil', ja: 'プロフィール', zh: '个人资料', ko: '프로필', hi: 'प्रोफ़ाइल', ar: 'الملف الشخصي' }),
                icon: 'user'
            },
            {
                text: AntLocalization.translateText({ vi: 'Đăng Xuất', en: 'Log Out', fr: 'Déconnexion', es: 'Cerrar sesión', id: 'Keluar', ja: 'ログアウト', zh: '登出', ko: '로그아웃', hi: 'लॉग आउट', ar: 'تسجيل الخروج' }),
                icon: 'runner',
                onClick: this.logOut
            }
        ];
    }

    componentDidMount() {
        onScreenChanged(this.screenSizeChanged);
    }

    componentWillUnmount() {
        offScreenChanged(this.screenSizeChanged);
    }

    render() {
        const { loggedIn } = this.state;
        return (
            <div className={`ant-app ${this.state.screenSizeClass} ${loggedIn ? `mainArea` : `authArea`}`}>
                <Router>
                    <div
                        style={{
                            width: '100%',
                            height: '100%',

                            backgroundImage:
                                !loggedIn && this.props.appAssets && this.props.appAssets.loginBackground
                                    ? `url(${this.props.appAssets.loginBackground})`
                                    : undefined,

                            backgroundRepeat: 'no-repeat',
                            backgroundAttachment: 'fixed',
                            backgroundSize: '100% 100%',

                            filter: blur('8px')
                        }}
                        className={`ant-app-container`}
                    >
                        {loggedIn ? (
                            <AntMainArea
                                userMenuItems={this.userMenuItems}
                                appNavigation={this.props.appNavigation}
                                appInfo={this.props.appInfo}
                                appAssets={this.props.appAssets}
                                appRoutes={this.props.appRoutes}
                                appConfig={this.props.appConfig}
                            />
                        ) : (
                            <AntAuthArea
                                appInfo={this.props.appInfo}
                                appAssets={this.props.appAssets}
                                onLogin={this.onLogin.bind(this)}
                                marginLeft={
                                    this.props.appInfo && this.props.appInfo.login && this.props.appInfo.login.alignLeft ? '100px' : undefined
                                }
                                marginRight={
                                    this.props.appInfo && this.props.appInfo.login && this.props.appInfo.login.alignRight ? '100px' : undefined
                                }
                            />
                        )}
                    </div>
                </Router>
            </div>
        );
    }

    screenSizeChanged = () => {
        this.setState({
            screenSizeClass: getScreenSizeClass()
        });
    };

    onLogin = () => {
        this.setState({ loggedIn: true });
    };

    logOut = () => {
        this.setState({ loggedIn: false });
    };
}

export default App;
